import {TaxiMessage} from "./taxi-message";

export class TaxiSearchUpdated implements TaxiMessage {
  constructor(public draftId: number, public started: string[], public stopped: string[]) {}

  getDraftId(): number {
    return this.draftId;
  }
}
